<template>
  <div>
    <b-form-row>

      <small>{{ $t('message.strata_col2') }}</small>
      <hr>
      <b-tabs pills card class="strata-inputs">
        <b-tab
          v-for="index in 4"
          :key="index - 1"
          :class="$v.strata.$each[index - 1].$invalid ? 'errorTab' : ''"
        >
          <template #title>
            <span :ref="'tab-' + String(index)">
              {{ '20' + String(vueAppYear - (index - 1)) }}
            </span>
          </template>
          <form-wrapper :validator="$v.strata.$each[4 - index]">
            <b-col>
              <text-group
                name="vykazana"
                :input-cols="6"
                :m="$v.strata.$each[4 - index]"
                :label="$t('message.strata_inputs.vykStraty')"
              />

              <text-group
                :input-cols="6"
                :m="$v.strata.$each[4 - index]"
                :disabled="index === 1"
                name="odpocitana"
                :label="$t('message.strata_inputs.strata24b')"
              />

              <text-group
                :input-cols="6"
                :m="$v.strata.$each[4 - index]"
                :disabled="index === 1"
                name="zostatok"
                :label="$t('message.strata_inputs.strata30and52podla24b')"
              />

              <text-group
                :input-cols="6"
                :m="$v.strata.$each[4 - index]"
                name="odpocitatelna"
                :label="$t('message.strata_inputs.strata30and52')"
              />
            </b-col>
          </form-wrapper>
          
        </b-tab>
      </b-tabs>
    </b-form-row>

    <b-button
      class="btn-primary"
      @click="strataSave"
    >
      {{ $t('message.lblSave') }}
    </b-button>
  </div>
</template>

<script>
import { minValue, decimal, maxValue } from 'vuelidate/lib/validators'
import restEditor from '@/mixins/restEditor'
import textGroup from '@/components/extractor/strataTextGroup.vue'

function strataArray () {
  return {
    vykazana: null,
    odpocitana: null,
    zostatok: null,
    odpocitatelna: null
  }
}

function postData () {
  return {
    id: null,
    parent: null,
    vykazana1: null, // 2016
    odpocitana1: null,
    zostatok1: null,
    odpocitatelna1: null,
    vykazana2: null,
    odpocitana2: null,
    zostatok2: null,
    odpocitatelna2: null,
    vykazana3: null,
    odpocitana3: null,
    zostatok3: null,
    odpocitatelna3: null,
    vykazana4: null, // 2019
    odpocitana4: null,
    zostatok4: null,
    odpocitatelna4: null
  }
}

export default {
  components: {
    textGroup
  },

  mixins: [restEditor],

  data() {
    return {
      id: null,
      parent: this.$route.params.userId,
      strata: [
        strataArray(),
        strataArray(),
        strataArray(),
        strataArray()
      ],
      vueAppYear: process.env.VUE_APP_YEAR
    }
  },


  validations: {
    strata: {
      $each: {
        vykazana: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0)
        },
        odpocitana: {
          decimal,
          maxValue: maxValue(9999999.99),
          minValue: minValue(0)
        },
        zostatok: {
          decimal,
          maxValue: maxValue(9999999.99),
          minValue: minValue(0)
        },
        odpocitatelna: {
          decimal,
          maxValue: maxValue(9999999.99),
          minValue: minValue(0)
        }
      }
    }
  },

  computed: {
    tabWithError () {
      const v = this.$v
      const errorTabs = []

      if (v.$invalid) {
        for (let i = 4; i > 0; i--) {
          const element = v.strata.$each[i - 1]
          if (element.$invalid) {
            errorTabs.push(4 - (i - 1))
          }
        }
      }

      return errorTabs
    }
  },

  watch: {
    tabWithError () {
      this.checkTabsForError()
    }
  },

  methods: {
    async processSave() {
      let items = postData()
      items.parent = this.$route.params.userId

      for (let i = 0; i < 4; i++) {
        items['vykazana' + String(i + 1)] = this.strata[i].vykazana
        items['odpocitana' + String(i + 1)] = this.strata[i].odpocitana
        items['zostatok' + String(i + 1)] = this.strata[i].zostatok
        items['odpocitatelna' + String(i + 1)] = this.strata[i].odpocitatelna
      }

      if (this.id === null) {
        const response = await this.restDataSource.createData(items, 'strata20')
        this.id = response.id
        console.log(response.id)
      } else {
        items.id = this.id
        await this.restDataSource.updateData(items, 'strata20')
      }
    },
    async processGet() {
      this.id = await this.restDataSource.getSposobId(this.parent, 'strata20')
      if (this.id !== null) {
        const items = await this.restDataSource.getData(this.id, 'strata20')

        for (let i = 0; i < 4; i++) {
          this.strata[i].vykazana = items['vykazana' + (i + 1)]
          this.strata[i].odpocitana = items['odpocitana' + (i + 1)]
          this.strata[i].zostatok = items['zostatok' + (i + 1)]
          this.strata[i].odpocitatelna = items['odpocitatelna' + (i + 1)]
        }
      }
    },

    checkTabsForError () {
      for (let i = 1; i <= 4; i++) {
        const updatedClass = this.$refs['tab-' + (i)][0].parentNode.classList

        if (this.tabWithError.includes(i)) {
          updatedClass.add('error')
        } else {
          updatedClass.remove('error')
        }
      }
    },

    strataSave () {
      this.$v.$touch()
      if (this.$v.$error) {
        this.checkTabsForError()
        return null
      }

      this.save()
    }
  }

};
</script>

<style>
.form-row > .col, .form-row > [class*="col-"] {
    padding-right: 30px;
    padding-left: 0px;
}
.form-check-label {
    margin-bottom: 12px;
}
.form-check-inline .form-check-input {
    margin-top: -12px;
}

.strata-inputs {
  width: 100%;
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  background-color: #3a5878;
  color: #fff!important;
  text-decoration: none!important;;
}
.card-header .nav-pills .nav-link:hover {
  color: #3a5878;
  text-decoration: underline;
}

.strata-inputs ul > li a.error {
  background-color: #df6a76;
  color: #fff;
}
.strata-inputs ul > li a.error:hover {
  color: #fff!important;
}
.strata-inputs ul > li a.active.error {
  background-color: #dc3545;
}
</style>
